import * as React from 'react';
import { Box, Button, useMediaQuery, useTheme } from "@mui/material";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router-dom';
import { tokens } from '../../Components/DashboardTheme/DashboardTheme';
import SectionHeading from '../../Components/SectionHeading/SectionHeading';
import Reveal from '../../Components/Reveal/Reveal';
import chiSiamoImg from '../../img/chi-siamo.webp';

export default function ChiSiamo() {
    const theme = useTheme();
    const isScreenSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();

    return (
        <Box component="section" id="chiSiamoSection" sx={{ backgroundColor: tokens.ink }}>
            <SectionHeading
                kicker="La palestra"
                title="CHI SIAMO"
                ghost="VIVENZIO"
                lead="Una famiglia allargata unita dall'amore per la Muay Thai. Dai principianti ai professionisti, qui si cresce insieme."
            />

            <Reveal>
                <Box
                    onClick={() => navigate('/storyVivenzioGym')}
                    sx={{
                        position: 'relative',
                        // Sized to the photo's own ratio (1638x1228) so cover()
                        // crops nothing. Width is capped so the shot isn't blown
                        // up past its native size on wide screens.
                        aspectRatio: '4 / 3',
                        maxWidth: 1150,
                        overflow: 'hidden',
                        cursor: 'pointer',
                        mx: 'auto',
                        width: { xs: 'calc(100% - 32px)', md: 'calc(100% - 96px)' },
                        mb: { xs: 6, md: 10 },
                        ':hover img': { transform: 'scale(1.06)' },
                        ':hover .vg-chisiamo-cta': { gap: '18px' },
                    }}
                >
                    <Box
                        component="img"
                        src={chiSiamoImg}
                        alt="Valentina Cancello ai colpitori con il maestro Mario Vivenzio"
                        sx={{
                            position: 'absolute',
                            inset: 0,
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            objectPosition: 'center center',
                            filter: 'grayscale(20%) brightness(0.55) contrast(1.06)',
                            transition: `transform 1.2s ${tokens.ease}`,
                        }}
                    />

                    {/* Scrim + hairline frame */}
                    <Box
                        aria-hidden
                        sx={{
                            position: 'absolute',
                            inset: 0,
                            background: `linear-gradient(180deg, transparent 40%, ${tokens.ink}D9 100%)`,
                        }}
                    />
                    <Box
                        aria-hidden
                        sx={{
                            position: 'absolute',
                            inset: { xs: 12, md: 20 },
                            border: `1px solid rgba(255,255,255,0.16)`,
                            pointerEvents: 'none',
                        }}
                    />

                    <Box
                        sx={{
                            position: 'absolute',
                            left: { xs: 24, md: 48 },
                            bottom: { xs: 28, md: 48 },
                            right: { xs: 24, md: 48 },
                        }}
                    >
                        <Box
                            sx={{
                                fontFamily: tokens.display,
                                fontSize: { xs: 30, md: 54 },
                                lineHeight: 1,
                                color: tokens.white,
                                mb: 2,
                            }}
                        >
                            L'ARTE DEGLI OTTO ARTI
                        </Box>
                        <Button
                            className="vg-chisiamo-cta"
                            endIcon={<ArrowForwardIcon />}
                            sx={{
                                color: tokens.white,
                                borderBottom: `2px solid ${tokens.red}`,
                                borderRadius: 0,
                                px: 0,
                                py: 1,
                                gap: '8px',
                                fontSize: isScreenSmall ? 13 : 15,
                                transition: `all 0.4s ${tokens.ease}`,
                                ':hover': { backgroundColor: 'transparent', color: tokens.red },
                            }}
                        >
                            Scopri la nostra storia
                        </Button>
                    </Box>
                </Box>
            </Reveal>
        </Box>
    );
}
